import React, { useEffect, useRef } from 'react';
import DailyIframe from '@daily-co/daily-js';

const DailyVideoConference = ({ roomUrl, onUserLeave, onMeetingJoined }) => {
    const wrapperRef = useRef(null);
    const dailyRef = useRef(null);

    useEffect(() => {
        // Apply full-page styles to body and html
        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100vh';
        document.body.style.width = '100vw';
        document.documentElement.style.height = '100vh';
        document.documentElement.style.width = '100vw';
        document.documentElement.style.overflow = 'hidden';

        if (!roomUrl || !wrapperRef.current) return;

        // Create the Daily iframe
        const createDailyInstance = async () => {
            try {
                // Initialize Daily iframe with fullscreen configuration
                dailyRef.current = DailyIframe.createFrame(wrapperRef.current, {
                    showLeaveButton: true,
                    iframeStyle: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                    },
                    showFullscreenButton: true,
                    showLocalVideo: true,
                });

                // Register event for when user leaves
                dailyRef.current.on('left-meeting', (event) => {
                    if (onUserLeave) {
                        onUserLeave({
                            event: 'user_left_meeting',
                            timestamp: new Date().toISOString(),
                            details: event
                        });
                    }
                });

                // Join the room
                await dailyRef.current.join({ url: roomUrl });

                if (onMeetingJoined) {
                    onMeetingJoined();
                }
            } catch (error) {
                console.error('Error setting up Daily:', error);
            }
        };

        createDailyInstance();

        // Clean up when the component unmounts
        return () => {
            // Restore default body styles
            document.body.style.margin = '';
            document.body.style.padding = '';
            document.body.style.overflow = '';
            document.body.style.height = '';
            document.body.style.width = '';
            document.documentElement.style.height = '';
            document.documentElement.style.width = '';
            document.documentElement.style.overflow = '';

            if (dailyRef.current) {
                // Leave the meeting and destroy the iframe
                dailyRef.current.leave()
                    .then(() => dailyRef.current.destroy())
                    .catch(console.error);
            }
        };
    }, [roomUrl, onUserLeave, onMeetingJoined]);

    return (
        <div className="daily-container" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100vw',
            height: '100vh',
            overflow: 'hidden',
            backgroundColor: '#000',
        }}>
            <div
                ref={wrapperRef}
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'relative'
                }}
            />
        </div>
    );
};

export default DailyVideoConference;